import { Component } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-reset-password-confirm',
  templateUrl: './reset-password-confirm.component.html',
  styleUrl: './reset-password-confirm.component.scss'
})
export class ResetPasswordConfirmComponent {
  uuid: string = ""
  success: boolean = false
  isSubmitting: boolean = false

  resetPasswordConfirmForm: UntypedFormGroup = new UntypedFormGroup({
    password: new UntypedFormControl('', Validators.required),
    confirmPassword: new UntypedFormControl('', Validators.required),
  });

  constructor(
    private _translateService: TranslateService,
    private route: ActivatedRoute,
    private _router: Router,
    private dataService: DataService
  ) {
    this.route.paramMap.subscribe(param => {this.uuid = param.get("uuid") as string});
  }

  reset() {
    this.isSubmitting = true
    this.dataService.resetPasswordConfirm(this.resetPasswordConfirmForm.get("password")?.value, this.uuid).subscribe(
      response => {
        this.success = true
        setTimeout(() => this._router.navigate(['/login']), 1500)
      },
      error => {
        console.error('Error:', error)
        this.isSubmitting = false
      }
    );
  }
}
